import { endOfDay, startOfDay } from "date-fns";

type RoundingDirection = "roundToEnd" | "roundToStart";
export const roundTimestamp = (
  unixTime: number,
  direction: RoundingDirection
): number => {
  const date = new Date(unixTime);
  if (direction === "roundToStart") {
    return startOfDay(date).getTime();
  }
  return endOfDay(date).getTime();
};
